/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function NetworkSecurity() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Network Protection Services
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Multi-layered security solutions designed to protect your network from internal and external threats.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Firewall Management
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Advanced firewall monitoring, configuration, and real-time threat protection.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Intrusion Detection & Prevention
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Proactive monitoring that identifies suspicious activity and blocks threats immediately.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Secure Remote Access
              </h3>
              <p className="text-surface-300 leading-relaxed">
                VPN, MFA, and identity controls that enable safe and secure remote work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Network Security Matters"
        subtitle="Your network is the backbone of your business — protecting it is essential to operations and growth."
        benefits={[
          {
            id: "threat-protection",
            title: "Protect Against Cyber Threats",
            text: "Prevent malware, ransomware, phishing and other attacks from compromising your network.",
            delay: 0,
          },
          {
            id: "reliability",
            title: "Ensure System Reliability",
            text: "Maintain strong connectivity and network performance with continuous monitoring.",
            delay: 120,
          },
          {
            id: "remote-security",
            title: "Secure Remote Workforce",
            text: "Provide safe access for remote employees without compromising your network.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "risk", text: "Reduced cyber risk" },
          { id: "access", text: "Stronger access control" },
          { id: "uptime", text: "Higher network uptime" },
          { id: "employee-security", text: "Improved employee security" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Need Stronger Network Protection?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              We build secure, reliable networks designed to keep your business safe.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
